import React from "react";

import CulturesInterfaceDropdown from "components/dropdowns/reactselect/CulturesInterfaceDropdown";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";
import CountryDropdown from "components/dropdowns/reactselect/CountryDropdown";
import { routes } from "utilities/routing/generatedRoutes";
import TimezoneDropdown from "components/dropdowns/reactselect/TimezoneDropdown";

// TODO: Rewrite this to use EditTemplate
export default class RegionalSettingsPanel extends React.Component<object, server.dto.UpdateUserRegionalPreferenceInstruction> {
  constructor(props) {
    super(props);

    this.state = { ...site.userPreference.regional, interfaceCulture: site.currentUser.culture, ianaTimeZoneId: site.userPreference.regional.ianaTimeZoneId };
  }

  onSave = async () => {
    await window.CoreApi.UserPreference.UpdateRegional(this.state);
    window.location.href = routes.personal_SettingMenu().absolute;
  };

  getCsvSeparatorOptions = (): Array<{ value: server.dto.CsvSeparators, text: string }> => {
    const semiColon: server.dto.CsvSeparators = "semicolon";
    const comma: server.dto.CsvSeparators = "comma";

    return [{ text: ",", value: comma }, { text: ";", value: semiColon }];
  };

  public render(): JSX.Element {
    return (<>
      <table className="s1_table clean rowspace">
        <tbody>
          <tr>
            <td>
              {RESX.Language.resxLanguage}
            </td>
            <td>
              <CulturesInterfaceDropdown
                value={serverReference.interfaceCultures.find(c => c.lcid === this.state.interfaceCulture)}
                onChange={c => { this.setState({ interfaceCulture: c.lcid }); }}
              />
            </td>
          </tr>
          <tr>
            <td>
              {RESX.DateTime.Timezone}
            </td>
            <td>
              <TimezoneDropdown
                value={this.state.ianaTimeZoneId}
                onChange={tz => { this.setState({ ianaTimeZoneId: tz }); }}
              />
            </td>
          </tr>
          <tr>
            <td>
              {RESX.Address.Country}
            </td>
            <td>
              <CountryDropdown
                value={serverReference.countries.find(c => c.key === this.state.country)}
                onChange={c => { this.setState({ country: c.key }); }}
              />

            </td>
          </tr>
          <tr>
            <td>
              {RESX.PersonalSettings.CsvSeparator}
            </td>
            <td>
              <BaseReactSelectDropdown
                options={this.getCsvSeparatorOptions()}
                value={this.getCsvSeparatorOptions().find(c => c.value === this.state.csvSeparator)}
                onChange={c => { this.setState({ csvSeparator: c.value }); }}
                getLabel={c => c.text}
                getValue={c => c.value}
                excludeKeys={[]}
                config={{}}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div className="flex justify-end margin-top-bigger">
        <button
          type="button"
          onClick={this.onSave}
          className="button-new primary">{RESX.Buttons.btnSave}</button>
      </div>
    </>);
  }
}
